
<div class="relative-container associated-form-section" :key="`detail-view-submission-list-${detailViewMode}`">
  <submission-filters v-if="showFilters"
                      :content-element="contentElement"
                      :linked-forms="linkedFormsForDropdownOptions"
                      @handleFilters="handleFilters">
  </submission-filters>
  <infinite-scroller-component :disabled="isPreview || !isElementFocusMode" @loadMore="fetchMore" :busy="fetchingMore" :fullyLoaded="isFullyLoaded">
    <submission-list v-if="submissionsSet"
                     :is-in-detail-view-edit-mode="isInEditMode"
                     :loading="loadingFormSubmissions"
                     :submissions="allFormSubmissions"
                     :submission-metadata="submissionMetadata"
                     :default-sort-details="sortDetails"
                     :initial-count="submissionLimit"
                     :total-count="totalCount"
                     :filters-on="filtersOn"
                     @updatePagination="updatePagination">
      <template slot="cta">
        <div>
          <router-link
            v-if="isDefaultMode"
            tag="button"
            class="btn blue"
            :to="showAllLinkRoute || isInEditMode "
            :disabled="isPreview">View All Forms</router-link>
        </div>
      </template>

    </submission-list>
  </infinite-scroller-component>
</div>
